import Vue from "vue";

export async function callApis(type, data) {
  let result = {
    assets: [],
  };
  for (let i = 0; i < data.assets.length; i++) {
    if (data.default_asset == data.assets[i].id) {
      const main = {};
      main.id = data.default_asset;
      const balanceRes = await getBalance(type, data.address);
      main.balance = balanceRes.data;
      result.assets.push(main);
    } else {
      let asset = {};
      asset.id = data.assets[i].id;

      let tokenBalanceRes = await getTokenBalance(
        type,
        data.address,
        data.assets[i].contract_address
      );
      asset.balance = tokenBalanceRes.data;
      result.assets.push(asset);
    }
  }
  console.log(result, "res");
  return result;
}

export async function getSingleBalance(type, chain, address, contract_address) {
  let balance = null;

  if (type == "main") {
    const balanceRes = await getBalance(chain, address);
    balance = balanceRes.data;

  } else {
    let tokenBalanceRes = await getTokenBalance(
      chain,
      address,
      contract_address
    );
    balance = tokenBalanceRes.data;
  }
  return balance;
}

function getBalance(chain, address) {
  return Vue.$axios({
    url: `https://api.auwallet.io/api/wallet/getBalance?chain=${chain}&address=${address}`,
    method: "get",
  });
}
function getTokenBalance(chain, address, contractAdress) {
  return Vue.$axios({
    url: `https://api.auwallet.io/api/wallet/getTokenBalance?chain=${chain}&address=${address}&contractAddress=${contractAdress}`,
    method: "get",
  });
}
export async function sendEncryptedWallets(data) {
  // let d = JSON.stringify()
    return Vue.$axios({
      // url: 'https://pdapi.moen.win/wtcenter/wallet/init',
      url: 'https://api.panda.fun/wtcenter/wallet/init',
      method: "post",
      data: data
    });
  
    // axios.post('https://pdapi.moen.win/wtcenter/wallet/init', wallets, {responseType: 'json', 'Content-Type': 'application/json'})
    // .then(response => {
    //     console.log(res)
    // })
    // .catch(err => {
    //     console.log(err)
    // })
  }
